/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForZohoServiceDeskCloud extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForZohoServiceDeskCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForZohoServiceDeskCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForZohoServiceDeskCloud>): ServiceAccountCredentialsForZohoServiceDeskCloud {
        let obj = Object.assign(new ServiceAccountCredentialsForZohoServiceDeskCloud(), model);
        ServiceAccountCredentialsForZohoServiceDeskCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForZohoServiceDeskCloud>): ServiceAccountCredentialsForZohoServiceDeskCloud {
        if (!model) return null;
        return ServiceAccountCredentialsForZohoServiceDeskCloud.newInstance(<ServiceAccountCredentialsForZohoServiceDeskCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForZohoServiceDeskCloud) {
        if (!obj) return;

        models.ServiceAccountCredentialsForZohoServiceDeskCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForZohoServiceDeskCloud): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForZohoServiceDeskCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Zoho ServiceDesk Datacenter. This is a required field.
     */
    data_center: models.ZohoServiceDeskDataCenter;

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Client Secret. This is a required field.
     */
    client_secret: string;

    /**
     * Authorization Code. This is a required field.
     */
    authorization_code: string;

}
